const { makeRequest } = require('services/api/ufeApi');
const { isBXSBrandEnabled } = require('utils/Cookies');

// https://jira.sephora.com/browse/INFL-1011

function getGroupedBrandsList() {
    let url = '/api/catalog/groupedBrandsList';

    if (isBXSBrandEnabled()) {
        url = '/api/v2/catalog/groupedBrandsList';
    }

    return makeRequest(url).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = { getGroupedBrandsList };
